import { render, staticRenderFns } from "./ManualImportForm.vue?vue&type=template&id=2d410bce&"
import script from "./ManualImportForm.vue?vue&type=script&lang=js&"
export * from "./ManualImportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports